import React, { Component } from "react";
import { browserHistory } from "react-router";
import { Field, reduxForm, FieldArray, formValueSelector } from "redux-form";
import { connect } from "react-redux";
import { formatOptionsList } from "./eventFormUtil";
import authSelector from "../../../selectors/authSelector";
import { Well, Button, ButtonToolbar } from "@sketchpixy/rubix";
import * as eventFormFields from "./EventFormFields";
import {
  appendToFormData,
  showAllServerErrorsAsNotifications
} from "../../../helpers/utility";
import autoCompleteSelect from "../FormFields/AutoCompleteSelect/AutoCompleteSelect";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { NotificationManager } from "react-notifications";
import TopStudentsOfEventModal from "./TopStudentsOfEventModal";
import {
  FETCH_COURSE_TOPICS_REQUEST,
  FETCH_GRADES_REQUEST,
  FETCH_EVENTS_REQUEST,
  // FETCH_EVENT_CATEGORIES_REQUEST,
  FETCH_STATES_REQUEST,
  CHECK_EVENT_TOP_STUDENTS_REQUEST,
  DELETE_EVENT_EXTENSION_REQUEST,
  DELETE_EVENT_TICKET_REQUEST,
  FETCH_ALL_EVENT_TEMPLATES_REQUEST
} from "../../../actions/actions";
import {
  fileInput,
  genericRadioButtonGroup,
  genericSelectInput,
  generalNumberInput,
  generalTextInput,
  checkboxInput
} from "../FormFields/Fields";
import GridedRow from "../GridedRow/GridedRow";
import * as MabnaButton from "../Button/Button";
import { filter } from "ramda";

// ────────────────────────────────────────────────────────────────────────────────

class AddEvent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: 0,
      topStudentsModalIsOpen: false,
      topStudentsData: undefined
    };
  }

  // ────────────────────────────────────────────────────────────────────────────────

  componentWillMount = () => {
    // load required data
    this.props.loadCourseTopics();
    this.props.loadGrades();
    this.props.loadAllEvents();
    // this.props.loadEventCategories()
    this.props.loadAllStates();
    this.props.loadAllEventTemplates();

    this.redirectIfNotManager();
  };

  // ────────────────────────────────────────────────────────────────────────────────

  redirectIfNotManager = () => {
    if (this.props.userType !== "MANAGER") {
      browserHistory.push("/dashboard/events");
    }
  };

  // ────────────────────────────────────────────────────────────────────────────────

  handleTabSelection = index => {
    this.setState({ activeTab: index });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  handleTicketRemove = (ticketIndex, successCallback) => {
    // in new events, we dont care it user deletes the ticket
    if (!this.props.editMode) return;

    // convert the index of the ticket to actual data
    const ticketData = this.props.tickets[ticketIndex];

    if (!ticketData || !ticketData.id) return;

    new Promise((resolve, reject) => {
      this.props.deleteTicket(ticketData.id, resolve, reject);
    })
      .then(() => {
        NotificationManager.success("بلیط حذف شد.");
        successCallback && successCallback();
      })
      .catch(error => {
        showAllServerErrorsAsNotifications(error);
      });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  handleExtensionRemove = (extensionIndex, successCallback) => {
    // in new events, we dont care it user deletes the extension
    if (!this.props.editMode) return;

    // convert the index of the extension to actual data
    const extension = this.props.extensions[extensionIndex];

    if (!extension || !extension.id) return;

    new Promise((resolve, reject) => {
      this.props.deleteExtension(extension.id, resolve, reject);
    })
      .then(() => {
        NotificationManager.success("افزونه حذف شد.");
        successCallback && successCallback();
      })
      .catch(error => {
        showAllServerErrorsAsNotifications(error);
      });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  showApprovedStudentsPreview = _ => {
    const formValues = this.props.approvedStudentsData;

    if (!formValues.percentage) return;

    new Promise((resolve, reject) => {
      const formData = appendToFormData({
        event: this.props.params.eventId,
        ...formValues
      });

      this.props.checkTopStudents(formData, resolve, reject);
    })
      .then(({ stats: { details } }) => {
        this.setState({
          topStudentsModalIsOpen: true,
          topStudentsData: details
        });
      })
      .catch(errors => {
        console.log(errors);
        NotificationManager.error("اشکالی رخ داد");
      });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  showAppreciationLetterPreview = _ => {
    const formValues = this.props.appreciatedStudentsData;

    if (!formValues.percentage) return;

    new Promise((resolve, reject) => {
      const formData = appendToFormData({
        event: this.props.params.eventId,
        ...formValues
      });

      this.props.checkTopStudents(formData, resolve, reject);
    })
      .then(({ stats: { details } }) => {
        this.setState({
          topStudentsModalIsOpen: true,
          topStudentsData: details
        });
      })
      .catch(errors => {
        console.log(errors);
        NotificationManager.error("اشکالی رخ داد");
      });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  getAllowedGradesForTickets = (allGrades, selectedGrades) =>
    formatOptionsList(
      allGrades.filter(grade => selectedGrades.includes(grade.id))
    );

  // ─────────────────────────────────────────────────────────────────

  handleTopStudentsModalClose = () => {
    this.setState({ topStudentsModalIsOpen: false });
  };

  handleTopStudentsModalOpen = () => {
    this.setState({ topStudentsModalIsOpen: true });
  };

  // ────────────────────────────────────────────────────────────────────────────────

  render() {
    const {
      handleSubmit,
      onSubmit,
      submitting,
      pristine,
      error,
      grades,
      courseTopics
    } = this.props;
    const submitHandler = handleSubmit(onSubmit);

    return (
      <div>
        <Well>
          <ButtonToolbar>
            <span>
              <span>افزودن رویداد حضوری جدید</span>
            </span>
          </ButtonToolbar>
        </Well>

        <div className="event-forms">
          <form onSubmit={submitHandler} className="create-update-event-form">
            <Tabs
              onSelect={this.handleTabSelection}
              selectedIndex={this.state.activeTab}
            >
              <TabList>
                <Tab>اطلاعات رویداد</Tab>
                <Tab disabled={!this.props.editMode}>بلیط ها و افزونه ها</Tab>
              </TabList>

              <TabPanel>
                <fieldset>
                  <legend>اطلاعات عمومی</legend>
                  <GridedRow columns={2}>
                    <Field name="title" component={eventFormFields.title} />

                    <Field
                      name="featured"
                      component={genericRadioButtonGroup}
                      title="رویداد برگزیده است"
                      options={[
                        { title: 'بله', id: 'true' },
                        { title: 'خیر', id: 'false' },
                      ]}
                    />
                  </GridedRow>

                  <GridedRow columns={2}>
                    {/* <Field
                      name="event_category"
                      component={eventFormFields.eventCategories}
                      options={this.props.eventCategories}
                    /> */}

                    <Field
                      name="pre_requisite_event"
                      component={autoCompleteSelect}
                      options={this.props.events}
                      isDisabled={
                        !this.props.events || !this.props.events.length
                      }
                      fieldName="pre_requisite_event"
                      title="رویداد پیش نیاز"
                    />
                  </GridedRow>

                  <GridedRow columns={2}>
                    <Field
                      name="grades"
                      component={autoCompleteSelect}
                      options={formatOptionsList(grades)}
                      fieldName="gradesField"
                      title="پایه های تحصیلی"
                      isMulti={true}
                    />

                    <Field
                      name="course_topics"
                      component={autoCompleteSelect}
                      options={formatOptionsList(courseTopics)}
                      title="دروس رویداد"
                      isMulti={true}
                    />
                  </GridedRow>

                  <GridedRow columns={2}>
                    <Field
                      name="thumbnail"
                      component={fileInput}
                      title="تصویرک"
                      showImagePreview={true}
                      accept="image/*"
                    />

                    <Field
                      name="cover"
                      component={fileInput}
                      title="تصویر اصلی"
                      showImagePreview={true}
                      accept="image/*"
                    />
                  </GridedRow>

                  <GridedRow columns={1}>
                    <Field
                      name="description"
                      title="توضیحات"
                      component={eventFormFields.wysiwygInput}
                    />
                  </GridedRow>
                </fieldset>

                <fieldset>
                  <legend>مدارک</legend>
                  <GridedRow columns={2}>
                    <Field
                      name="badge_template"
                      component={autoCompleteSelect}
                      title="قالب کارت ورود به جلسه"
                      options={this.props.eventTemplates.badges}
                    />

                    <Field
                      name="certificate_template"
                      component={autoCompleteSelect}
                      title="قالب گواهی رویداد"
                      options={this.props.eventTemplates.certificates}
                    />

                    <Field
                      name="results_template"
                      component={autoCompleteSelect}
                      title="قالب کارنامه"
                      options={this.props.eventTemplates.results}
                    />
                  </GridedRow>
                </fieldset>

                <fieldset>
                  <legend>اطلاعات زمان رویداد</legend>
                  <GridedRow columns={2}>
                    <Field
                      name="register_date"
                      component={eventFormFields.registerDate}
                    />
                    <Field
                      name="register_end_date"
                      component={eventFormFields.registerEndDate}
                    />
                  </GridedRow>

                  <GridedRow columns={2}>
                    <Field
                      name="event_date"
                      component={eventFormFields.eventDate}
                    />
                    <Field
                      name="event_end_date"
                      component={eventFormFields.eventEndDate}
                    />
                  </GridedRow>

                  <GridedRow columns={1}>
                    <Field
                      name="dates_description"
                      component={eventFormFields.datesDesc}
                    />
                  </GridedRow>
                </fieldset>

                <fieldset>
                  <legend>تنظیمات نماینده</legend>

                  <GridedRow columns={2}>
                    <Field
                      name="has_agent"
                      component={eventFormFields.hasAgent}
                    />
                    {this.props.eventHasAgent && (
                      <Field
                        name="agent_share"
                        component={eventFormFields.agentShare}
                      />
                    )}
                  </GridedRow>
                </fieldset>

                <fieldset style={{display: 'none'}}>
                  <legend>تنظیمات برگزیدگی دانش آموز</legend>

                  <GridedRow columns={3}>
                    <Field
                      name="approved_students"
                      component={fileInput}
                      placeholder="فایل اکسل"
                      title="لیست برگزیدگان"
                    />

                    <Field
                      name="approval_criteria_percent"
                      component={generalNumberInput}
                      title="درصد برگزیدگان رویداد"
                      placeholder="درصد"
                      min="0"
                      step="1"
                    />

                    <Field
                      name="approval_criteria_per_province"
                      component={checkboxInput}
                      // title="نحوه محاسبه برگزیدگان"
                      options={[{ id: "true", title: "محاسبه بصورت استانی" }]}
                    />
                  </GridedRow>

                  <Button
                    type="button"
                    bsStyle="info"
                    bsSize="small"
                    onClick={this.showApprovedStudentsPreview}
                    disabled={!this.props.editMode}
                  >
                    پیش نمایش نتایج
                  </Button>
                </fieldset>

                <fieldset style={{ display: "none" }}>
                  <legend>تنظیمات دریافت تقدیر نامه</legend>
                  <GridedRow columns={3}>
                    <Field
                      name="appreciation_letter_students"
                      component={fileInput}
                      placeholder="فایل اکسل"
                      title="لیست دریافت کنندگان تقدیر نامه"
                    />

                    <Field
                      name="appreciation_letter_criteria_percent"
                      component={generalNumberInput}
                      title="درصد دریافت کنندگان تقدیر نامه"
                      placeholder="درصد"
                      min="0"
                      step="1"
                    />

                    <Field
                      name="appreciation_letter_criteria_per_province"
                      component={checkboxInput}
                      // title="نحوه محاسبه دریافت کنندگان تقدیر نامه"
                      options={[{ id: "true", title: "محاسبه بصورت استانی" }]}
                    />
                  </GridedRow>

                  <Button
                    type="button"
                    bsStyle="info"
                    bsSize="small"
                    onClick={this.showAppreciationLetterPreview}
                    disabled={!this.props.editMode}
                  >
                    پیش نمایش نتایج
                  </Button>
                </fieldset>

                <fieldset>
                  <legend>ثبت نام خودکار دانش آموزان</legend>
                  <Field
                    name="registered_students"
                    component={fileInput}
                    placeholder="فایل اکسل"
                    title="لیست ثبت نام"
                  />
                </fieldset>

                <fieldset>
                  <legend>تنظیمات بیشتر</legend>
                  <GridedRow columns={2}>
                    <Field
                      name="contest_id"
                      component={generalTextInput}
                      placeholder="شناسه گندم"
                      title="شناسه گندم"
                    />
                  </GridedRow>
                </fieldset>

                <section
                  style={{ textAlign: "center", padding: "5px", color: "red" }}
                >
                  {error && <strong>{error}</strong>}
                </section>

                <MabnaButton.Primary
                  type="submit"
                  disabled={submitting || pristine}
                >
                  {submitting ? "در حال ارسال..." : "ذخیره"}
                </MabnaButton.Primary>
              </TabPanel>

              <TabPanel>
                {this.props.editMode && (
                  <fieldset className="create-update-event-form__tickets">
                    <legend>بلیط های رویداد</legend>

                    <FieldArray
                      name="tickets"
                      title="بلیط ها"
                      component={eventFormFields.tickets}
                      allowedGrades={this.getAllowedGradesForTickets(
                        grades,
                        this.props.selectedGrades
                      )}
                      states={this.props.states}
                      onTicketRemove={this.handleTicketRemove}
                    />
                  </fieldset>
                )}

                {this.props.editMode && (
                  <fieldset>
                    <legend>افزونه ها</legend>
                    <FieldArray
                      name="extensions"
                      title="افزونه ها"
                      component={eventFormFields.extensions}
                      onExtensionRemove={this.handleExtensionRemove}
                    />
                  </fieldset>
                )}

                <section
                  style={{ textAlign: "center", padding: "5px", color: "red" }}
                >
                  {error && <strong>{error}</strong>}
                </section>

                <MabnaButton.Primary
                  type="submit"
                  disabled={submitting || pristine}
                >
                  {submitting ? "در حال ارسال..." : "ذخیره"}
                </MabnaButton.Primary>
              </TabPanel>
            </Tabs>
          </form>
        </div>

        <TopStudentsOfEventModal
          isOpen={this.state.topStudentsModalIsOpen}
          onClose={this.handleTopStudentsModalClose}
          data={this.state.topStudentsData}
        />
      </div>
    );
  }
}

// ────────────────────────────────────────────────────────────────────────────────

const validate = values => {
  let errors = {};

  if (!values.title) {
    errors.title = "عنوان رویداد الزامی است";
  }

  // if (!values.event_category) {
  //   errors.event_category = 'نوع رویداد الزامی است'
  // }

  return errors;
};

// ────────────────────────────────────────────────────────────────────────────────

AddEvent = reduxForm({
  form: "AddEvent",
  validate
})(AddEvent);

// ────────────────────────────────────────────────────────────────────────────────

const selectorValueSelector = formValueSelector("AddEvent");

const mapStateToProp = (state, ownProps) => {
  const events = state.eventsList.result.map(
    eventId => state.eventsList.entities.event[eventId]
  );

  const defaultInitialValues = {
    grades: [],
    approval_criteria_per_province: false,
    appreciation_letter_criteria_per_province: false,
    has_agent: false,
    featured: false
  };

  const initialValues = ownProps.initialValues || defaultInitialValues;

  return {
    // injected props form store
    events,
    grades: state.grades,
    ...authSelector(state),
    courseTopics: state.courseTopics,
    // eventCategories: state.eventCategories.list,
    eventTemplates: state.eventTemplates,

    // form initial values
    initialValues: filter(x => x !== null, initialValues),

    // form current values
    selectedGrades: selectorValueSelector(state, "grades") || [],
    states: state.states.map(({ id, name: title }) => ({ id, title })),
    tickets: selectorValueSelector(state, "tickets") || [],
    extensions: selectorValueSelector(state, "extensions") || [],
    eventHasAgent:
      selectorValueSelector(state, "has_agent") === "true" || false,

    approvedStudentsData: {
      percentage: selectorValueSelector(state, "approval_criteria_percent"),
      perProvince: selectorValueSelector(
        state,
        "approval_criteria_per_province"
      )
    },

    appreciatedStudentsData: {
      percentage: selectorValueSelector(
        state,
        "appreciation_letter_criteria_percent"
      ),
      perProvince: selectorValueSelector(
        state,
        "appreciation_letter_criteria_per_province"
      )
    }
  };
};

// ────────────────────────────────────────────────────────────────────────────────

const mapDispatchToProps = {
  loadCourseTopics: () => ({
    type: FETCH_COURSE_TOPICS_REQUEST
  }),
  loadGrades: () => ({
    type: FETCH_GRADES_REQUEST,
    force: true,
  }),
  loadAllEvents: () => ({
    type: FETCH_EVENTS_REQUEST,
    all: true
  }),
  // loadEventCategories: () => ({
  //   type: FETCH_EVENT_CATEGORIES_REQUEST,
  // }),
  loadAllStates: () => ({
    type: FETCH_STATES_REQUEST
  }),
  checkTopStudents: (formData, resolve, reject) => ({
    type: CHECK_EVENT_TOP_STUDENTS_REQUEST,
    formData,
    resolve,
    reject
  }),
  deleteExtension: (extensionId, resolve, reject) => ({
    type: DELETE_EVENT_EXTENSION_REQUEST,
    extensionId,
    resolve,
    reject
  }),
  deleteTicket: (ticketId, resolve, reject) => ({
    type: DELETE_EVENT_TICKET_REQUEST,
    ticketId,
    resolve,
    reject
  }),
  loadAllEventTemplates: () => ({
    type: FETCH_ALL_EVENT_TEMPLATES_REQUEST
  })
};

// ────────────────────────────────────────────────────────────────────────────────

export default connect(
  mapStateToProp,
  mapDispatchToProps
)(AddEvent);



// WEBPACK FOOTER //
// ./src/components/common/events/AddEvent.js